<template>
  <div class="page flex-col">
    <div class="text-wrapper_1 flex-row justify-between">
      <span class="text_1">不止为您防范风险，更为您创造价值&ensp;——
        <span class="text_2">高效、专业、勤勉、尽责</span>
      </span>
    </div>
    <div class="group_1 flex-col">
      <div class="block_1 flex-row">
        <div class="box_1 flex-col">
          <span class="text_3">快速链接</span>
          <div class="box_2 flex-row justify-between">
            <span class="text_4"><a href="https://exmail.qq.com/login" target="_blank">企业邮箱</a></span>
            <img class="thumbnail_1" referrerpolicy="no-referrer" src="@/assets/img/footer/1.png" />
          </div>
          <div class="box_3 flex-row justify-between">
            <span class="text_5"><a href="https://picture.feizufg.com/file/disclaimer.pdf" target="_blank">免责声明</a></span>
            <img class="thumbnail_2" referrerpolicy="no-referrer" src="@/assets/img/footer/1.png" />
          </div>
        </div>
        <div class="text-wrapper_2 flex-col">
          <span class="text_6">联系我们</span>
          <span class="text_7">咨询电话：<a href="tel:8618188641716" target="_blank">181-8864-1716</a></span>
          <span class="text_8">咨询微信：<a href="tel:8618188641716" target="_blank">181-8864-1716</a></span>
        </div>
        <img class="image_1" referrerpolicy="no-referrer" src="@/assets/img/footer/2.png" />
      </div>
      <div class="block_2 flex-row">
        <span class="text_9"><a href="https://picture.feizufg.com/file/protocol.pdf" target="_blank">隐私政策</a></span>
        <img class="thumbnail_3" referrerpolicy="no-referrer" src="@/assets/img/footer/1.png" />
        <span class="text_10">联系地址：广东省深圳市福田区益田路江苏大厦A座23层</span>
        <span class="text_11">微信立即咨询</span>
      </div>
      <div class="block_3 flex-col"></div>
      <span class="text_12">©{{ new Date().getFullYear() }}&nbsp;北京市东元（深圳）律师事务所&nbsp;版权所有&nbsp;
        <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2021147654号-1</a></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  },
};
</script>
<style lang="scss" scoped>
.page {
  background-color: rgba(255, 255, 255, 1);
  width: 100%;
  min-width: 1440px;
  height: 311px;
  overflow: hidden;
  position: absolute;
  bottom: 1;
  left: 0;
  right: 0;
  margin: auto;
}

.text-wrapper_1 {
  background-color: rgba(253, 145, 84, 1);
  width: 100%;
  height: 64px;
}

.text_1 {
  width: 326px;
  height: 29px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 24px;
  font-family: 思源黑体;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 24px;
  margin: 0 auto;
  margin-top: 18px;
  justify-content: center;
  align-items: center;
  display: flex;
}

.text_2 {
  width: 240px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 8px;
}

.group_1 {
  background-color: rgba(51, 51, 51, 1);
  width: 100%;
  height: 247px;
  justify-content: center;
  align-items: center;
  display: flex;
}

.block_1 {
  width: 947px;
  height: 91px;
  margin: 30px 0 0 0;
}

.box_1 {
  width: 86px;
  height: 91px;
}

.text_3 {
  width: 86px;
  height: 24px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Inter-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.box_2 {
  width: 73px;
  height: 19px;
  margin-top: 15px;
}

.text_4 {
  width: 67px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.text_4 a,
.text_5 a,
.text_9 a {
  text-decoration: none;
  color: rgba(255, 255, 255, 1);
}

.thumbnail_1 {
  width: 6px;
  height: 6px;
  margin-top: 7px;
}

.box_3 {
  width: 73px;
  height: 19px;
  margin-top: 14px;
}

.text_5 {
  width: 67px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}

.thumbnail_2 {
  width: 6px;
  height: 6px;
  margin-top: 6px;
}

.text-wrapper_2 {
  width: 231px;
  height: 91px;
  margin-left: 100px;

  a {
    color: rgba(255, 255, 255, 1);
  }
}

.text_6 {
  width: 86px;
  height: 24px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Inter-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_7 {
  width: 231px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 14px;
}

.text_8 {
  width: 209px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 15px;
}

.image_1 {
  width: 88px;
  height: 88px;
  margin-left: 440px;
}

.block_2 {
  width: 947px;
  height: 21px;
  margin: 11px 0 0 0;
}

.text_9 {
  width: 67px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 2px;
}

.thumbnail_3 {
  width: 6px;
  height: 6px;
  margin-top: 9px;
}

.text_10 {
  width: 400px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 2px 0 0 113px;
}

.text_11 {
  width: 99px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: 思源黑体;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin-left: 267px;
}

.block_3 {
  background-color: rgba(102, 102, 102, 1);
  width: 1024px;
  height: 1px;
  margin: 30px 0 0 0;
}

.text_12 {
  width: 685px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(102, 102, 102, 1);
  font-size: 12px;
  font-family: 思源黑体;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 12px;
  margin: 24px 0 24px 0;

  a {
    color: rgba(102, 102, 102, 1);
  }
}

a {
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Footer/index.vue